<template>
    <Modal ref="modal" class="stocks-add-items-button" @closed="onModalClose">
        <template #header="sp">
            <div class="h3">Ajouter des produits au stock</div>
        </template>
        <template #body="sp">
            <div class="form-group row">
                <label for="stock" class="col-4 col-form-label">Stock</label>
                <div class="col-8">
                    <select class="form-control" id="stock" v-model="selectedStock">
                        <option v-for="stock in stocks" :value="stock">{{ stock.name }}</option>
                    </select>
                </div>
            </div>

            <div class="form-group row">
                <label for="item" class="col-4 col-form-label">Produit/Composant</label>
                <div class="col-8">
                    <select class="form-control mr-1" id="item" v-model="selectedItem">
                        <optgroup label="Produits">
                            <option v-for="item in products" :value="{type: 'product', sku: item.sku}">{{ item.sku }} - {{ item.name }}</option>
                        </optgroup>
                        <optgroup label="Composants">
                            <option v-for="item in components" :value="{type: 'component', sku: item.sku}">{{ item.sku }} - {{ item.name }}</option>
                        </optgroup>
                    </select>
                </div>
            </div>

            <div class="form-group row">
                <label for="quantity" class="col-4 col-form-label">Quantité</label>
                <div class="col-8">
                    <InputIntegerPositive class="form-control" id="quantity" v-model="quantity" />
                </div>
            </div>

            <ErrorsZone :errors="errors" />
        </template>
        <template #footer>
            <button class="btn btn-outline-dark" @click="closeModal">
                Annuler
            </button>
            <button class="btn btn-success" @click="onClickAddButton">
                Ajouter au stock
            </button>
        </template>
        <template #button>
            <slot :show-modal="showModal"></slot>
        </template>
    </Modal>
</template>

<script>
    import ErrorsZone from "../../ErrorsZone";
    import InputIntegerPositive from "../../InputIntegerPositive"
    import Modal from "../../Modal";

    import {usePostRequest} from "../../compositions/axios/postRequest";

    export default {
        name: 'StocksAddItemsButton',

        components: {
            ErrorsZone,
            InputIntegerPositive,
            Modal,
        },

        setup() {
            const {
                loading: sending,
                errors,
                post
            } = usePostRequest();

            return {
                sending,
                errors,
                post
            };
        },

        props: {
            stocks: {
                type: Array,
                required: true,
            },
            products: {
                type: Array,
                required: true,
            },
            components: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                selectedStock: null,
                selectedItem: null,
                quantity: 0,
            };
        },

        methods: {
            showModal() {
                this.$refs.modal.showModal();
            },

            closeModal() {
                this.$refs.modal.closeModal();
            },

            onModalClose() {
                this.quantity = 0;
                this.errors = null;
            },

            async onClickAddButton(e) {
                if (!this.validateFields()) {
                    e.preventDefault();
                    return false;
                }

                const response = await this.post('/espace-employes/production/stocks/ajouter-produits', {
                    stock: this.selectedStock.id,
                    sku: this.selectedItem.sku,
                    quantity: this.quantity,
                });

                if (!this.errors) {
                    this.closeModal();

                    //if (!this.$root.echoConnectedWihoutErrors) {
                        window.location.reload();
                    //}
                }
            },

            validateFields() {
                this.errors = null;

                let errors = {};

                if (!this.selectedStock) {
                    errors['selectedStock'] = ["Le stock est obligatoire."];
                }

                if (!this.selectedItem) {
                    errors['selectedItem'] = ["Le produit est obligatoire."];
                }

                if (isNaN(this.quantity)) {
                    errors['quantity'] = ["La quantité est invalide. (nombre entier positif requis)"];
                } else if (this.quantity <= 0) {
                    errors['quantity'] = ["La quantité doit être supérieure à 0."];
                }

                if (Object.keys(errors).length > 0) {
                    this.errors = { message: "Merci de corriger les erreurs suivantes :", errors: errors };
                    return false;
                }

                return true;
            },
        },
    }
</script>

<style lang="scss">
    .stocks-add-items-button {
        :first-of-type(.modal-container) {
            max-width: 600px;
            width: auto;
        }
    }
</style>
